var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-dialog',{ref:"dialog",attrs:{"title":"字段配置","enable-flex":"","width":"420","mode":"slide","mask-close":""},on:{"resolve":_vm.submitHandle}},[_c('field-config-list',{ref:"fieldConfig",staticClass:"flex-grow flex-column",attrs:{"private":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }